import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localeData from 'dayjs/plugin/localeData';
import dayjs from './dayjs_timezone';
import 'dayjs/locale/af';
import 'dayjs/locale/sq';
import 'dayjs/locale/ar-dz';
import 'dayjs/locale/ar';
import 'dayjs/locale/az';
import 'dayjs/locale/bs';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/bg';
import 'dayjs/locale/ca';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-hk';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/hr';
import 'dayjs/locale/cs';
import 'dayjs/locale/da';
import 'dayjs/locale/nl';
import 'dayjs/locale/nl-be';
import 'dayjs/locale/de';
import 'dayjs/locale/en-au';
import 'dayjs/locale/en-nz';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/es';
import 'dayjs/locale/eo';
import 'dayjs/locale/et';
import 'dayjs/locale/eu';
import 'dayjs/locale/fo';
import 'dayjs/locale/fi';
import 'dayjs/locale/fr';
import 'dayjs/locale/gl';
import 'dayjs/locale/ka';
import 'dayjs/locale/el';
import 'dayjs/locale/he';
import 'dayjs/locale/hi';
import 'dayjs/locale/hu';
import 'dayjs/locale/is';
import 'dayjs/locale/id';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/kk';
import 'dayjs/locale/km';
import 'dayjs/locale/ko';
import 'dayjs/locale/lv';
import 'dayjs/locale/lt';
import 'dayjs/locale/lb';
import 'dayjs/locale/mk';
import 'dayjs/locale/ml';
import 'dayjs/locale/ms';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/fa';
import 'dayjs/locale/ro';
import 'dayjs/locale/ru';
import 'dayjs/locale/sk';
import 'dayjs/locale/sl';
import 'dayjs/locale/sr';
import 'dayjs/locale/sv';
import 'dayjs/locale/fr-ch';
import 'dayjs/locale/ta';
import 'dayjs/locale/th';
import 'dayjs/locale/tr';
import 'dayjs/locale/uk';
import 'dayjs/locale/vi';

dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
dayjs.extend(localeData);

function setLocale(locale) {
  if (locale && dayjs.locale() !== locale) dayjs.locale(locale);
}

function formatDay(day, locale) {
  return dayjs(day).locale(locale).format('ddd ll');
}

function formatMonthTitle(date, locale) {
  return dayjs(date).locale(locale).format('MMMM YYYY');
}

function formatWeekdayShort(i, locale) {
  setLocale(locale);
  return dayjs.weekdaysMin()[i];
}

function formatWeekdayLong(i, locale) {
  setLocale(locale);
  return dayjs.weekdays()[i];
}

function getFirstDayOfWeek(locale) {
  setLocale(locale);
  try {
    const localeData = dayjs().localeData(locale);
    return localeData.firstDayOfWeek();
  } catch (e) {
    return localeData.firstDayOfWeek();
  }
}

function getMonths(locale) {
  setLocale(locale);
  const months = [];
  let i = 0;
  while (i < 12) {
    months.push(dayjs().month(i).format('MMMM'));
    i += 1;
  }
  return months;
}

export default {
  setLocale,
  formatDay,
  formatMonthTitle,
  formatWeekdayShort,
  formatWeekdayLong,
  getFirstDayOfWeek,
  getMonths,
};
